import { LOGOUT, RESET_CURRENT_REPORT, SET_REPORT_ID, SET_CURRENT_REPORT, SET_REPORTS_LIST } from "../actions/types";

const INITIAL_STATE = {
    reportID: null,
    current: {
        reportID: null,
        dateFrom: null,
        dateTo: null,
        generatedOn: null,
        content: [],
        externalContent: {},
        outsideContent: []
    },
    list: [],
    pages: null
};

const canteenReportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_REPORT_ID:
            return {
                ...state,
                reportID: action.payload
            };
        case SET_CURRENT_REPORT:
            const content = [];
            const internRow = {
                userID: -7,
                fname: "",
                lname: "Praktykant",
                totalPrice: 0.0,
                foundedPrice: 0.0
            };
            const externalContent = {};
            const outsideContent = [];

            action.payload.content.forEach(row => {
                if (row.intern === 0) {
                    if (row.externalOuID !== null) {
                        if (!externalContent[row.externalOuID]) externalContent[row.externalOuID] = {
                            externalOuName: row.externalOuName,
                            content: []
                        }
                        externalContent[row.externalOuID].content.push({
                            userID: row.userID,
                            fname: row.fname,
                            lname: row.lname,
                            totalPrice: row.totalPrice,
                            foundedPrice: row.foundedPrice,
                            ...row
                        });
                    }
                    else (row.outside === 0 ? content : outsideContent).push({
                        userID: row.userID,
                        fname: row.fname,
                        lname: row.lname,
                        totalPrice: row.totalPrice,
                        foundedPrice: row.foundedPrice,
                        ...row
                    });

                } else {
                    const { userID, fname, lname, intern, totalPrice, foundedPrice, ...meals } = row;
                    Object.keys(meals).forEach(meal => {
                        if (internRow[meal]) internRow[meal] += +meals[meal];
                        else internRow[meal] = +meals[meal];
                    });
                    internRow.totalPrice = Math.round((internRow.totalPrice + +row.totalPrice) * 100) / 100;
                    internRow.foundedPrice = Math.round((internRow.foundedPrice + +row.foundedPrice) * 100) / 100;
                }
            });
            if (+internRow.totalPrice > 0.0 && +internRow.foundedPrice > 0.0) {
                internRow.totalPrice = (internRow.totalPrice).toFixed(2);
                internRow.foundedPrice = (internRow.foundedPrice).toFixed(2);
                content.push(internRow);
            }

            return {
                ...state,
                current: {
                    reportID: action.payload.reportID,
                    dateFrom: action.payload.dateFrom,
                    dateTo: action.payload.dateTo,
                    generatedOn: action.payload.generatedOn,
                    content: content,
                    externalContent: externalContent,
                    outsideContent: outsideContent
                }
            };
        case SET_REPORTS_LIST:
            return {
                ...state,
                list: action.payload.canteenReports.map(report => {
                    return {
                        reportID: report.reportID,
                        dateFrom: report.dateFrom,
                        dateTo: report.dateTo,
                        generatedOn: report.generatedOn,
                        canceled: report.canceled,
                        canceledOn: report.canceledOn,
                        settled: report.settled,
                        settledOn: report.settledOn
                    };
                }),
                pages: action.payload.pages
            };
        case RESET_CURRENT_REPORT:
            return {
                ...state,
                reportID: INITIAL_STATE.reportID,
                current: INITIAL_STATE.current
            }
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default canteenReportReducer;